import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Heading,
  IconButton,
} from '@chakra-ui/react';
import { ButtonCustom } from '../../components/UI';
import { CartDTO } from '../../../modules/cart/types';
import { commitCartAction } from '../../../modules/cart/actions';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import useCustomToast from '../../components/UI/toast';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../constants/routes';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { selectAllCarts } from '../../../modules/cart/selectors';

interface CheckoutProps {
  checkoutItems: CartDTO['order_items'];
  tempAmounts: { [key: string]: number | null };
  onProceedToCheckout: () => void;
}

export const Checkout: React.FC<CheckoutProps> = ({
  checkoutItems,
  tempAmounts,
  onProceedToCheckout,
}) => {
  const dispatch = useAppDispatch();
  const allCarts = useAppSelector(selectAllCarts);
  const toast = useCustomToast();
  const navigate = useNavigate();

  const checkoutTotal = checkoutItems.reduce(
    (sum, item) => sum + (tempAmounts[item.pk] || item.amount) * parseFloat(String(item.price)),
    0,
  );

  return (
    <Box>
      <Flex alignItems="center" onClick={onProceedToCheckout} cursor="pointer">
        <IconButton aria-label="Back" icon={<ChevronLeftIcon boxSize="32px" />} variant="ghost" />
        <Heading size="lg">Назад</Heading>
      </Flex>
      <Text fontSize="2xl" fontWeight="bold" mb={6} textAlign="center">
        Оплата заказа
      </Text>
      <Table variant="simple" size="md" bg="white" borderRadius="md" shadow="sm">
        <Thead bg="gray.100">
          <Tr>
            <Th>Наименование</Th>
            <Th>Комментарий</Th>
            <Th>Ожид. срок</Th>
            <Th>Кол-во</Th>
            <Th textAlign="right">Цена</Th>
          </Tr>
        </Thead>
        <Tbody>
          {checkoutItems.map(item => (
            <Tr key={item.pk}>
              <Td fontWeight="bold">{item.good_name}</Td>
              <Td>{item.comment}</Td>
              <Td>{item.delivery_term} дн.</Td>
              <Td>{tempAmounts[item.pk]}</Td>
              <Td textAlign="right">
                {(
                  parseFloat(String(item.price)) * (tempAmounts[item.pk] || item.amount)
                ).toLocaleString()}{' '}
                ₽
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Flex w="100%" justifyContent="center" mt={8}>
        <ButtonCustom
          variant="withBackground"
          width="280px"
          height="48px"
          colorScheme="blue"
          onClick={() => {
            dispatch(commitCartAction.request(allCarts?.pk || ''));
            toast('Заказ отправлен на оплату', 'success');
            navigate(routes.ORDERS);
          }}
        >
          Оплатить {checkoutTotal.toLocaleString()} ₽
        </ButtonCustom>
      </Flex>
    </Box>
  );
};
